import { ProductSearchFilter, SortOrder } from '@model/product/ProductSearchResult'
import { KK_LANG_IDS, Locale } from '@model/locales'
import { getIdFromQueryParam } from '@utils/getIdFromQueryParam'

export function parseProductSearchQueryToApiFilters(query: string): Partial<ProductSearchFilter> {
  const parsedQuery = Object.fromEntries(new URLSearchParams(query))

  const { page = '1', id, locale, brands, minPrice, maxPrice, count = '30', sorting, searchTerm } = parsedQuery

  const currentPage = parseInt(page as string)
  const pageLimit = parseInt(count as string)
  const offset = pageLimit * currentPage - pageLimit
  const currentLocale = (locale as Locale) || 'et'
  const languageId = KK_LANG_IDS[currentLocale]

  return {
    categoryId: id ? parseInt(id as string) : undefined,
    languageId,
    manufacturerIds: brands ? brands.toString().split(',').map(getIdFromQueryParam) : undefined,
    priceFrom: minPrice ? parseFloat(minPrice.toString()) : undefined,
    priceTo: maxPrice ? parseFloat(maxPrice.toString()) : undefined,
    offset,
    orderBy: sorting as SortOrder,
    // tagGroups:facets ?? undefined,
  }
}
